import ActionButton from '!!raw-loader!./ActionButton.vue'
import Icon from '!!raw-loader!./Icon.vue'
import Tool from '!!raw-loader!./Tool.vue'

export default {
  ActionButton,
  Icon,
  Tool,
}
